import { render, staticRenderFns } from "./FeedTankGeneralSection.vue?vue&type=template&id=0f5a431e&"
import script from "./FeedTankGeneralSection.vue?vue&type=script&lang=ts&"
export * from "./FeedTankGeneralSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports